
document.addEventListener("DOMContentLoaded", function () {

  const inquiryButton = document.querySelector('button[aria-controls="custom#select_inquiry_-selector-dropdown"]');
  const inquiryText = document.querySelector('button[aria-controls="custom#select_inquiry_-selector-dropdown"] ._selectToggleText_12thd_25');
  const appointmentDate = document.querySelector('[data-testid="date-birthday"]');

  if (appointmentDate) {
    appointmentDate.style.display = "none";
  }

  document.addEventListener("click", function (e) {

    if (e.target.getAttribute("role") === "option") {

      const selectedValue = e.target.innerText.trim();
      inquiryText.innerText = selectedValue;

      if (selectedValue === "Send appointment") {
        appointmentDate.style.display = "block";
      } else {
        appointmentDate.style.display = "none";
      }
    }
  });

});


